import { useSyncExternalStore } from 'react';
import {
  getKnowledgeGraphSnapshot,
  subscribeKnowledgeGraph,
  findRelatedNodes,
  type KGSnapshot,
} from '@gotti/sandbox-ai-v2';

/**
 * Subscribe a component to the knowledge graph. Re-renders on any
 * `notify()` from the store. The snapshot returned is the entire graph;
 * use `findRelatedNodes(id, depth)` for cheaper targeted lookups when
 * you only care about one node's neighbourhood.
 *
 * The store itself lives in @gotti/sandbox-ai-v2 (no React); this file
 * is the thin React adapter.
 */
export function useKnowledgeGraph(): KGSnapshot {
  return useSyncExternalStore(
    subscribeKnowledgeGraph,
    getKnowledgeGraphSnapshot,
    getKnowledgeGraphSnapshot,
  );
}

export { findRelatedNodes };
